import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsLinkComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-header-faq',
    templateUrl: './header-faq.component.html',
    styleUrl: './header-faq.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeaderFaqComponent implements OnInit {

  public componentData$: Observable<CmsLinkComponent>;

  constructor(public component: CmsComponentData<CmsLinkComponent>) { }

  ngOnInit(): void {
    this.componentData$ = this.component.data$;
  }
}
